import React from 'react'
import { useReadOnly } from '../../contexts/ReadOnlyContext'

// Solid-fill Yes/No pill buttons - used everywhere a checklist/co-author
// question needs a tri-state (unanswered/yes/no) answer. Plain native radios
// looked out of place next to the rest of the app's button styling.
export default function YesNoToggle({ value, onChange, disabled: disabledProp = false }) {
  const readOnly = useReadOnly()
  const disabled = disabledProp || readOnly
  const base = 'px-3 py-1 text-sm font-medium rounded-lg border-1 disabled:opacity-50'
  const inactive = 'bg-white dark:bg-rb-dark-mode text-rb-mat-grey dark:text-rb-dark-mode-text-grey border-rb-widget-border dark:border-rb-dark-mode-lighter'

  return (
    <div className="flex gap-2 shrink-0">
      <button
        type="button"
        disabled={disabled}
        onClick={() => onChange(true)}
        className={`${base} ${value === true ? 'bg-rb-green text-white border-rb-green' : inactive}`}
      >
        Yes
      </button>
      <button
        type="button"
        disabled={disabled}
        onClick={() => onChange(false)}
        className={`${base} ${value === false ? 'bg-red-500 text-white border-red-500' : inactive}`}
      >
        No
      </button>
    </div>
  )
}
